/* DDUDDI fixes JS — loaded BEFORE dduddi-custom.js so this header logic wins.
   1) Preserves the header (WISH/cart) and claims the guard so dduddi-custom's
      headerMenu (which replaced the locale selector with a dead label) skips.
   2) Builds a WORKING custom language selector from the real Shopify
      localization <form> (which Dawn renders display:none here). */
(function () {
  /* Locale-aware path: Shopify.routes.root is '/' on the primary locale and
     '/ko/', '/en/' etc. elsewhere. Hardcoding '/account' dropped the locale, so
     the customer-account login page opened in English on a Korean page. */
  function R(p) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/+$/, '') + p;
  }

  /* Force clean English menu labels from the collection/page handle, so the
     translation app's awkward auto-Korean (딸, 정보 …) never shows. MK uses
     English category names on every locale. */
  var MENU_MAP = { bibs: 'BIBS', baby: 'BABY', kids: 'KIDS', hats: 'HATS', daughter: 'DAUGHTER', supima: 'SUPIMA', knit: 'KNIT', 'inner-wear': 'INNER WEAR', about: 'ABOUT BRAND', contact: 'CONTACT US', 'fw-collection': 'FW COLLECTION', collection: 'LOOKBOOK' };
  function labelFor(h) {
    var m = (h || '').match(/\/(collections|pages)\/([^\/?#]+)/);
    if (!m) return null;
    var seg = decodeURIComponent(m[2]).toLowerCase();
    return MENU_MAP[seg] || seg.replace(/-/g, ' ').toUpperCase();
  }
  function relabelMenus() {
    var links = document.querySelectorAll('.header__inline-menu a, .header__submenu a, .menu-drawer a[href*="/collections/"], .menu-drawer a[href*="/pages/"]');
    [].forEach.call(links, function (a) {
      if (a.classList.contains('header__menu-item-link')) return; /* SHOP's own dropdown-parent link keeps its fixed "SHOP" label, not the target collection's name */
      var lbl = labelFor(a.getAttribute('href'));
      if (!lbl) return;
      for (var i = 0; i < a.childNodes.length; i++) {
        var n = a.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = lbl; return; }
      }
      var sp = a.querySelector('span');
      if (sp) sp.textContent = lbl;
    });
  }
  /* The SHOP dropdown parent (desktop native menu + mobile drawer) has no
     product/page href of its own, so its <summary> just displays whatever
     Shopify's own menu translation rendered for the active locale (seen: ja
     showed "SHOP" as "店舗") -- every other nav label on this site is forced
     to a fixed English string (MENU_MAP / gnbMenu()'s SHOP fallback below),
     so fix this one the same way. Desktop's own summary text isn't visible
     (gnbMenu() rebuilds a separate panel from it) but the mobile drawer
     reuses Dawn's native summary as-is, so it needs the direct fix. */
  function fixShopSummary() {
    var summaries = document.querySelectorAll('.menu-drawer summary, .header__inline-menu summary');
    [].forEach.call(summaries, function (s) {
      if (s.querySelector('a')) return;
      /* The locale-translated label is a bare text node directly in the
         <summary> (its siblings are icon-only <span class="svg-wrapper">s) --
         same text-node walk relabelMenus() uses for <a> labels above. */
      for (var i = 0; i < s.childNodes.length; i++) {
        var n = s.childNodes[i];
        if (n.nodeType === 3 && n.textContent.trim()) { n.textContent = 'SHOP'; return; }
      }
    });
  }

  /* Store info in the footer: Korean on ko, Japanese on ja, English elsewhere. */
  function footerLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('ko') === 0) return; /* Korean: keep original */
    var comp = null;
    [].forEach.call(document.querySelectorAll('.footer .footer-block__details-content'), function (el) {
      if (/137-86-56474/.test(el.textContent)) comp = el;
    });
    if (!comp) return;
    if (lang.indexOf('ja') === 0) {
      comp.innerHTML =
        '<p>DEAR SOOA Co., Ltd.(ディアスア) · 代表 キム・ジャヨン</p>' +
        '<p>事業者登録番号 137-86-56474<span class="dd-fsep"> · </span><br class="dd-fbr">通信販売業申告番号 第2026-ソウル城東-1034号</p>' +
        '<p>大韓民国 ソウル特別市城東区ソウルスプ2キル8-7, 1階(郵便番号05628)</p>' +
        '<p>カスタマーセンター +82-10-7640-3740 · 平日 10:00〜17:00(昼休み 12:00〜13:00 / 土日・祝日休業)</p>' +
        '<p>個人情報保護責任者 キム・ジャヨン · メール dearsooa8@gmail.com</p>';
      return;
    }
    comp.innerHTML =
      '<p>DEAR SOOA Co., Ltd. · CEO Kim Jayeon</p>' +
      '<p>Business Registration No. 137-86-56474<span class="dd-fsep"> · </span><br class="dd-fbr">Mail-Order Sales License No. 2026-Seoul Seongdong-1034</p>' +
      '<p>1F, 8-7 Seoulsup 2-gil, Seongdong-gu, Seoul 05628, Republic of Korea</p>' +
      '<p>Customer Center +82-10-7640-3740 · Weekdays 10:00–17:00 (Lunch 12:00–13:00 / Closed on weekends & holidays)</p>' +
      '<p>Privacy Officer Kim Jayeon · Email dearsooa8@gmail.com</p>';
  }
  /* Footer: break the 통신판매업신고 / Mail-Order License item onto its own line
     on mobile (subtext setting can't hold classed <br>/<span>, so do it here). */
  function footerBreak() {
    var comp = null;
    [].forEach.call(document.querySelectorAll('.footer .footer-block__details-content'), function (el) {
      if (/137-86-56474/.test(el.textContent)) comp = el;
    });
    if (!comp) return;
    var p = [].filter.call(comp.querySelectorAll('p'), function (x) { return /137-86-56474/.test(x.textContent); })[0];
    if (!p || p.querySelector('.dd-fbr')) return;
    p.innerHTML = p.innerHTML.replace(/\s*·\s*(통신판매업신고|Mail-Order)/, '<span class="dd-fsep"> · </span><br class="dd-fbr">$1');
  }

  /* Cart count bubble: Dawn re-renders the whole #cart-icon-bubble link (via
     the cart-icon-bubble section) on every add/remove, which both replaces
     our appended .dd-cart-n span AND leaves it stale if it survives. A
     one-time copy at page load (the old approach) goes wrong as soon as the
     cart changes without a full page reload. Watch the icons row instead so
     the custom number is re-created/re-synced on every cart update. */
  function cartCountSync() {
    var icons = document.querySelector('.header .header__icons');
    if (!icons || icons.__ddCartObs) return;
    function sync() {
      var cart = icons.querySelector('.header__icon--cart');
      if (!cart) return;
      var bub = cart.querySelector('.cart-count-bubble');
      /* .cart-count-bubble has TWO text spans: the visible count and a
         "N items" screen-reader label. bub.textContent concatenates both
         (e.g. "2" + "2 items" = "22 items"), so reading the visible span
         alone is required - textContent of the whole bubble double-counts. */
      var countEl = bub ? bub.querySelector('[aria-hidden="true"]') : null;
      var n = countEl ? ((countEl.textContent.match(/\d+/) || ['0'])[0]) : '0';
      var s = cart.querySelector('.dd-cart-n');
      if (!s) {
        s = document.createElement('span');
        s.className = 'dd-cart-n';
        cart.appendChild(s);
      }
      if (s.textContent !== n) s.textContent = n;
    }
    sync();
    icons.__ddCartObs = 1;
    new MutationObserver(sync).observe(icons, { subtree: true, childList: true, characterData: true });
  }

  function headerMenuFix() {
    var icons = document.querySelector('.header .header__icons');
    if (!icons || icons.getAttribute('data-dd-header')) return;
    icons.setAttribute('data-dd-header', '1'); /* claim it -> dduddi-custom skips */

    /* globe glyph in the localization wrapper */
    var loc = icons.querySelector('.desktop-localization-wrapper');
    if (loc && !loc.querySelector('.dd-globe')) {
      loc.classList.add('dd-loc-live');
      var g = document.createElement('span');
      g.className = 'dd-globe';
      g.setAttribute('aria-hidden', 'true');
      g.innerHTML = '<svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="10" cy="10" r="8"></circle><ellipse cx="10" cy="10" rx="4" ry="8"></ellipse><line x1="2" y1="10" x2="18" y2="10"></line></svg>';
      loc.insertBefore(g, loc.firstChild);
    }

    /* ACCOUNT text link: <shopify-account> is a web component whose click
       handler lives on a shadow-DOM button, so the CSS ::after label on the
       host was unclickable. Insert a real link beside it. */
    var acct = icons.querySelector('.header__icon--account');
    if (acct && !icons.querySelector('.dd-acct')) {
      var a2 = document.createElement('a');
      a2.href = R('/account');
      a2.className = 'header__icon dd-acct link';
      a2.innerHTML = '<span class="dd-hlabel">ACCOUNT</span>';
      acct.parentNode.insertBefore(a2, acct.nextSibling);
    }

    /* WISH link before the cart. */
    var cart = icons.querySelector('.header__icon--cart');
    if (cart && !icons.querySelector('.header__icon--wish')) {
      var w = document.createElement('a');
      w.href = R('/account');
      w.className = 'header__icon header__icon--wish link';
      w.setAttribute('aria-label', 'Wish');
      w.innerHTML = '<span class="dd-wish-ic" aria-hidden="true">♡</span><span class="dd-hlabel">WISH</span>';
      cart.parentNode.insertBefore(w, cart);
    }

    cartCountSync();
  }

  /* Working language selector: submits Shopify's /localization form. */
  function langSelector() {
    var wrap = document.querySelector('.header .desktop-localization-wrapper');
    if (!wrap || wrap.getAttribute('data-dd-lang')) return;
    var forms = wrap.querySelectorAll('form.localization-form');
    /* language form = the one whose hidden input is named locale_code */
    var form = null;
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="locale_code"]')) { form = forms[i]; break; }
    }
    if (!form) return;
    wrap.setAttribute('data-dd-lang', '1');

    var input = form.querySelector('input[name="locale_code"]');
    var current = input ? input.value : '';
    var links = [].slice.call(form.querySelectorAll('.disclosure__list a, ul a'));
    var opts = links.map(function (a) {
      return { code: a.getAttribute('data-value') || a.getAttribute('lang') || '', label: (a.textContent || '').trim() };
    }).filter(function (o) { return o.code && o.label; });
    if (!opts.length) return;

    var curLabel = (opts.filter(function (o) { return o.code === current; })[0] || opts[0]).label;

    form.style.display = 'none'; /* hide Dawn's collapsed original */

    var box = document.createElement('div');
    box.className = 'dd-lang';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dd-lang__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="dd-lang__cur"></span><span class="dd-lang__car" aria-hidden="true"><svg viewBox="0 0 10 6" width="9" height="6" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 1l4 4 4-4"/></svg></span>';
    btn.querySelector('.dd-lang__cur').textContent = curLabel;

    var list = document.createElement('ul');
    list.className = 'dd-lang__list';
    opts.forEach(function (o) {
      var li = document.createElement('li');
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'dd-lang__opt';
      a.textContent = o.label;
      if (o.code === current) a.setAttribute('aria-current', 'true');
      a.addEventListener('click', function () {
        if (o.code === current) { close(); return; }
        if (input) input.value = o.code;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    function open() { box.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { box.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); box.classList.contains('is-open') ? close() : open(); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    box.appendChild(btn);
    box.appendChild(list);
    wrap.appendChild(box);
  }

  /* Working footer country selector: same globe+label+caret pattern as the
     header language selector (langSelector above), so a customer whose
     market cookie is stuck on the wrong country (e.g. left over from the
     domain/market mixup) has a visible, working way to switch back — this
     was previously hidden theme-wide along with every other native
     localization form. Submits Shopify's real /localization form. */
  function footerCountrySelector() {
    var wrap = document.querySelector('.footer .footer__localization');
    if (!wrap || wrap.getAttribute('data-dd-country')) return;
    var forms = wrap.querySelectorAll('form.localization-form');
    var form = null;
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('input[name="country_code"]')) { form = forms[i]; break; }
    }
    if (!form) return;
    wrap.setAttribute('data-dd-country', '1');

    var input = form.querySelector('input[name="country_code"]');
    var current = input ? input.value : '';
    var links = [].slice.call(form.querySelectorAll('.disclosure__list a, ul a'));
    var opts = links.map(function (a) {
      var nameEl = a.querySelector('.country');
      return { code: a.getAttribute('data-value') || '', label: ((nameEl ? nameEl.textContent : a.textContent) || '').trim() };
    }).filter(function (o) { return o.code && o.label; });
    if (!opts.length) return;

    var curOpt = opts.filter(function (o) { return o.code === current; })[0] || opts[0];

    form.style.display = 'none'; /* hide Dawn's collapsed original */

    var box = document.createElement('div');
    box.className = 'dd-country';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dd-country__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="dd-globe" aria-hidden="true"><svg viewBox="0 0 20 20" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="10" cy="10" r="8"></circle><ellipse cx="10" cy="10" rx="4" ry="8"></ellipse><line x1="2" y1="10" x2="18" y2="10"></line></svg></span><span class="dd-country__cur"></span><span class="dd-country__car" aria-hidden="true"><svg viewBox="0 0 10 6" width="9" height="6" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 1l4 4 4-4"/></svg></span>';
    btn.querySelector('.dd-country__cur').textContent = curOpt.label;

    var list = document.createElement('ul');
    list.className = 'dd-country__list';
    opts.forEach(function (o) {
      var li = document.createElement('li');
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'dd-country__opt';
      a.textContent = o.label;
      if (o.code === current) a.setAttribute('aria-current', 'true');
      a.addEventListener('click', function () {
        if (o.code === current) { close(); return; }
        if (input) input.value = o.code;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    function open() { box.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close() { box.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) { e.stopPropagation(); box.classList.contains('is-open') ? close() : open(); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    box.appendChild(btn);
    box.appendChild(list);
    wrap.insertBefore(box, wrap.firstChild);
  }

  /* Desktop GNB (MK, 2-level): the MENU trigger opens a full-width bar with the
     TOP-LEVEL nav (SHOP / COLLECTION / ABOUT BRAND / CONTACT US); SHOP keeps its product
     categories in a hover/focus dropdown, so product menus sit ONE level under SHOP
     instead of being flattened alongside COLLECTION. Preserves the real 2-level
     Shopify nav. Desktop only; the mobile drawer is untouched. */
  function gnbMenu() {
    var header = document.querySelector('.header');
    var nav = header && header.querySelector('.header__inline-menu');
    if (!header || !nav || nav.getAttribute('data-dd-gnb')) return;
    var ul = nav.querySelector('.list-menu--inline');
    if (!ul) return;

    /* Parent (e.g. SHOP): <li><header-menu><details><summary><span>LABEL</span>...
       </summary><ul class="header__submenu">...children...</ul></details></header-menu></li>.
       Leaf: <li><a>LABEL</a></li>. Keep the two levels. */
    var tops = [];
    [].forEach.call(ul.children, function (li) {
      var directA = li.querySelector(':scope > a');
      var summary = li.querySelector('summary');
      var href = '', label = '';
      if (directA) {
        href = directA.getAttribute('href') || '';
        label = labelFor(href) || directA.textContent.trim().toUpperCase();
      } else if (summary) {
        var sa = summary.querySelector('a');
        href = sa ? (sa.getAttribute('href') || '') : '';
        var sp = summary.querySelector('span');
        /* A dropdown parent with no product/page href (e.g. "SHOP") has no
           handle for labelFor() to key off, so it fell back to reading the
           live rendered text -- which Shopify's own menu translation can
           replace per locale (seen: ja rendered "SHOP" as "店舗"), breaking the
           always-English nav labels used everywhere else in this menu.
           Hardcode it instead, consistent with MENU_MAP's other entries. */
        label = (href && labelFor(href)) || 'SHOP';
      }
      if (!label) return;
      var subs = [];
      [].forEach.call(li.querySelectorAll('.header__submenu a'), function (a) {
        var h = a.getAttribute('href');
        if (h) subs.push({ t: labelFor(h) || a.textContent.trim(), h: h });
      });
      tops.push({ t: label, h: href, subs: subs });
    });
    if (!tops.length) return;

    nav.setAttribute('data-dd-gnb', '1');
    nav.classList.add('dd-gnb');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'dd-gnb__trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = 'MENU';
    nav.insertBefore(trigger, ul);

    var panel = document.createElement('div');
    panel.className = 'dd-gnb__panel';
    var pu = document.createElement('ul');
    pu.className = 'dd-gnb__list';
    tops.forEach(function (top) {
      var li = document.createElement('li');
      li.className = 'dd-gnb__item' + (top.subs.length ? ' dd-gnb__item--has' : '');
      var link;
      if (top.h) { link = document.createElement('a'); link.href = top.h; }
      else { link = document.createElement('button'); link.type = 'button'; }
      link.className = 'dd-gnb__link';
      link.textContent = top.t;
      li.appendChild(link);
      if (top.subs.length) {
        var su = document.createElement('ul');
        su.className = 'dd-gnb__sub';
        top.subs.forEach(function (sub) {
          var sli = document.createElement('li');
          var sa2 = document.createElement('a');
          sa2.href = sub.h;
          sa2.className = 'dd-gnb__sublink';
          sa2.textContent = sub.t;
          sli.appendChild(sa2);
          su.appendChild(sli);
        });
        li.appendChild(su);
      }
      pu.appendChild(li);
    });
    panel.appendChild(pu);
    header.appendChild(panel);

    var closeT;
    function open() { clearTimeout(closeT); panel.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
    function close() { closeT = setTimeout(function () { panel.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }, 140); }
    [trigger, panel].forEach(function (el) {
      el.addEventListener('mouseenter', open);
      el.addEventListener('mouseleave', close);
    });
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      panel.classList.contains('is-open') ? (clearTimeout(closeT), panel.classList.remove('is-open'), trigger.setAttribute('aria-expanded', 'false')) : open();
    });
    document.addEventListener('click', function (e) { if (!panel.contains(e.target) && e.target !== trigger) { panel.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); } });
  }

  /* Mobile menu drawer (MK): utility row = Search / Wishlist / Account, then the
     language selector (globe) at the very bottom. Hide the single-market country
     selector so it matches desktop + MK's clean single locale line. */
  function drawerFix() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer || drawer.querySelector('.dd-drawer-util')) return; /* claim -> dduddi-custom skips */
    var SEARCH = '<svg viewBox="0 0 18 18" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="7.6" cy="7.6" r="5.4"></circle><line x1="11.6" y1="11.6" x2="16" y2="16"></line></svg>';
    var HEART = '<svg viewBox="0 0 20 20" width="19" height="19" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M10 16.5S3.8 12.8 3.8 8.4A3.1 3.1 0 0110 6.9a3.1 3.1 0 016.2 1.5c0 4.4-6.2 8.1-6.2 8.1z"></path></svg>';
    var USER = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.3"><circle cx="10" cy="6.5" r="3.2"></circle><path d="M4 16.6c0-3.1 2.7-5.1 6-5.1s6 2 6 5.1"></path></svg>';
    var GLOBE = '<svg viewBox="0 0 20 20" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.1"><circle cx="10" cy="10" r="8"></circle><ellipse cx="10" cy="10" rx="4" ry="8"></ellipse><line x1="2" y1="10" x2="18" y2="10"></line></svg>';

    var util = document.createElement('div');
    util.className = 'dd-drawer-util';
    util.innerHTML =
      '<a href="' + R('/search') + '"><span aria-hidden="true">' + SEARCH + '</span>Search</a>' +
      '<a href="' + R('/account') + '"><span aria-hidden="true">' + HEART + '</span>Wishlist</a>' +
      '<a href="' + R('/account') + '"><span aria-hidden="true">' + USER + '</span>Account</a>';
    var ulink = drawer.querySelector('.menu-drawer__utility-links');
    if (ulink) ulink.parentNode.insertBefore(util, ulink);
    else (drawer.querySelector('.menu-drawer__inner-container') || drawer).appendChild(util);

    /* localization: hide country (single market), keep language + globe, move to bottom */
    /* Language: build a custom selector (globe + label + options) INSIDE the main
       menu list, submitting the real localization form. Dawn's native drawer
       button collapses (text hidden), so we don't reuse it visually. */
    var loc = drawer.querySelector('.menu-drawer__localization');
    var menu = drawer.querySelector('.menu-drawer__menu');
    if (loc && menu) {
      var lform = null;
      [].forEach.call(loc.querySelectorAll('form.localization-form'), function (f) {
        if (f.querySelector('input[name="locale_code"]')) lform = f;
      });
      if (lform) {
        var linput = lform.querySelector('input[name="locale_code"]');
        var lcur = linput ? linput.value : '';
        var lopts = [].slice.call(lform.querySelectorAll('.disclosure__list a, ul a')).map(function (a) {
          return { code: a.getAttribute('data-value') || a.getAttribute('lang') || '', label: (a.textContent || '').trim() };
        }).filter(function (o) { return o.code && o.label; });
        if (lopts.length) {
          var lcurLabel = (lopts.filter(function (o) { return o.code === lcur; })[0] || lopts[0]).label;
          loc.style.display = 'none'; /* hide native UI; keep form in DOM to submit */
          var li = document.createElement('li');
          li.className = 'dd-drawer-langitem';
          var box = document.createElement('div');
          box.className = 'dd-lang2';
          var lbtn = document.createElement('button');
          lbtn.type = 'button';
          lbtn.className = 'dd-lang2__btn';
          lbtn.setAttribute('aria-expanded', 'false');
          lbtn.innerHTML = '<span class="dd-globe" aria-hidden="true">' + GLOBE + '</span><span class="dd-lang2__cur"></span><span class="dd-lang2__car" aria-hidden="true"><svg viewBox="0 0 10 6" width="10" height="6" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M1 1l4 4 4-4"/></svg></span>';
          lbtn.querySelector('.dd-lang2__cur').textContent = lcurLabel;
          var llist = document.createElement('ul');
          llist.className = 'dd-lang2__list';
          lopts.forEach(function (o) {
            var oli = document.createElement('li');
            var ob = document.createElement('button');
            ob.type = 'button';
            ob.className = 'dd-lang2__opt';
            ob.textContent = o.label;
            if (o.code === lcur) ob.setAttribute('aria-current', 'true');
            ob.addEventListener('click', function () {
              if (o.code === lcur) { box.classList.remove('is-open'); return; }
              if (linput) linput.value = o.code;
              if (lform.requestSubmit) lform.requestSubmit(); else lform.submit();
            });
            oli.appendChild(ob);
            llist.appendChild(oli);
          });
          lbtn.addEventListener('click', function () {
            box.classList.toggle('is-open');
            lbtn.setAttribute('aria-expanded', box.classList.contains('is-open') ? 'true' : 'false');
          });
          box.appendChild(lbtn);
          box.appendChild(llist);
          li.appendChild(box);
          menu.appendChild(li);
        }
      }
    }
  }

  /* CONTACT page: store info is hard-coded Korean in the page template. On a
     non-Korean locale, swap the HEAD OFFICE / CUSTOMER SERVICE blocks to
     Japanese (ja) or English (everything else). Detail <p> uses
     white-space:pre-line, so \n renders as line breaks. */
  function contactLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('ko') === 0) return;
    var ja = lang.indexOf('ja') === 0;
    var items = document.querySelectorAll('.dd-contact .dd-contact__detail');
    if (!items.length) return;
    [].forEach.call(items, function (p) {
      if (p.getAttribute('data-dd-en')) return;
      var t = p.textContent;
      if (/137-86-56474/.test(t)) {
        p.textContent = ja
          ? 'DEAR SOOA Co., Ltd.(ディアスア) · 代表 キム・ジャヨン\n'
            + '大韓民国 ソウル特別市城東区ソウルスプ2キル8-7, 1階(郵便番号05628)\n'
            + '事業者登録番号 137-86-56474 · 通信販売業申告番号 第2026-ソウル城東-1034号\n'
            + '個人情報保護責任者 キム・ジャヨン'
          : 'DEAR SOOA Co., Ltd. · CEO Kim Jayeon\n'
            + '1F, 8-7 Seoulsup 2-gil, Seongdong-gu, Seoul 05628, Republic of Korea\n'
            + 'Business Registration No. 137-86-56474 · Mail-Order Sales License No. 2026-Seoul Seongdong-1034\n'
            + 'Privacy Officer Kim Jayeon';
        p.setAttribute('data-dd-en', '1');
      } else if (/고객센터|010-7640-3740/.test(t)) {
        p.textContent = ja
          ? 'カスタマーセンター +82-10-7640-3740\n'
            + '平日 10:00〜17:00(昼休み 12:00〜13:00)\n'
            + '土日・祝日休業'
          : 'Customer Center +82-10-7640-3740\n'
            + 'Weekdays 10:00–17:00 (Lunch 12:00–13:00)\n'
            + 'Closed on weekends & holidays';
        p.setAttribute('data-dd-en', '1');
      }
    });
  }

  /* DDUDDI: lock the first-purchase 100-won promo product everywhere it can
     appear (product page, Quick Add modal, anywhere else). The button itself
     ships as `disabled` plus an inline <script> guard in buy-buttons.liquid,
     but Dawn's Quick Add modal (quick-add.js) fetches the product page and
     injects its HTML via innerHTML - and inline <script> tags never execute
     when inserted that way, so that guard silently no-ops there while Dawn's
     own variant-availability JS still re-enables the disabled attribute.
     This file, unlike that injected fragment, is always loaded as a real
     <script src> and actually executes, so enforce it from here instead via
     delegation: works no matter how/where the button entered the DOM. */
  function lockPromoProduct() {
    if (document.__ddPromoLockBound) return;
    document.__ddPromoLockBound = true;

    function disableAll() {
      var btns = document.querySelectorAll('[data-dd-locked-product="true"]');
      for (var i = 0; i < btns.length; i++) { if (!btns[i].disabled) btns[i].disabled = true; }
    }
    disableAll();

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.querySelector && form.querySelector('[data-dd-locked-product=\"true\"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes') {
          if (m.target.getAttribute && m.target.getAttribute('data-dd-locked-product') === 'true' && !m.target.disabled) {
            m.target.disabled = true;
          }
        } else if (m.addedNodes && m.addedNodes.length) {
          disableAll();
        }
      }
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  }

  /* DDUDDI: first-purchase 100-won promo banner's "100원에 담기" button
     (snippets/cart-drawer.liquid + sections/main-cart-footer.liquid). Both
     ship the click handler as an inline <script> next to the button, which
     works on a real full page load (e.g. landing straight on /cart) but
     silently never binds when the banner first appears via an AJAX cart
     update - adding an item from a product page fetches the re-rendered
     cart-drawer section and swaps it in via innerHTML, and inline <script>
     tags never execute when inserted that way. That's the same class of bug
     documented on lockPromoProduct() above. Centralize the handler here
     instead: this file is always loaded as a real <script src>, so binding
     the delegated listener on load covers the button no matter which of the
     two places it appears in, or how many times its container gets
     re-rendered afterward. */
  function wirePromoAddButton() {
    if (document.__ddPromoAddBound) return;
    document.__ddPromoAddBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dd-promo-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled) return;
      var errorEl = btn.parentElement.querySelector('[data-dd-promo-error]');
      if (errorEl) errorEl.hidden = true;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '담는 중...';
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.getAttribute('data-variant-id'), quantity: 1 })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || 'error');
            return data;
          });
        })
        .then(function () {
          /* Only the drawer's copy of this banner needs the reopen flag - a
             reload lands back on the same /cart page on its own, so setting
             this there too would pop the drawer open ON TOP of /cart for no
             reason (main-cart-footer.liquid's original inline script never
             set it either). */
          if (btn.closest('cart-drawer')) {
            try { sessionStorage.setItem('dd_cart_open_after_reload', '1'); } catch (e) {}
          }
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          if (errorEl) {
            errorEl.textContent = '담기에 실패했습니다. 다시 시도해주세요.';
            errorEl.hidden = false;
          }
        });
    });
  }

  /* footerCountrySelector() is defined above but not called: the market that
     made it necessary (see its own comment) was set to draft/disabled on
     2026-09-08 instead, which removes the stuck-market failure mode at the
     source. Left wired up (not deleted) in case a market mixup happens
     again later - re-add `footerCountrySelector();` to this list to turn it
     back on. */
  window.addEventListener('load', function () { relabelMenus(); fixShopSummary(); headerMenuFix(); langSelector(); gnbMenu(); drawerFix(); footerLocale(); footerBreak(); contactLocale(); lockPromoProduct(); wirePromoAddButton(); });
})();
